<template>
  <div>
    <el-drawer
      title="阿里商品详情"
      size="1000px"
      :visible.sync="dialogVisible"
      append-to-body
      :before-close="handleClose">

      <div v-if="productData" class="product-container">
        <div class="info">
          <div class="left">
            <el-carousel height="360px" v-if="productData.productImage">
              <el-carousel-item v-for="item in productData.productImage.images" :key="item">
                <el-image :src="item"></el-image>
              </el-carousel-item>
            </el-carousel>

          </div>
          <div class="right">
            <div class="title">{{ productData.subject }}</div>
            <div class="attributes">
              <div v-if="productData.bizType"><span>业务类型：</span>{{ bizTypes[productData.bizType] }}</div>
              <div v-if="productData.supplierLoginId"><span>供应商：</span>{{ productData.supplierLoginId }}</div>
              <div v-if="productData.productCargoNumber"><span>商品货号：</span>{{ productData.productCargoNumber }}
              </div>
              <div v-if="productData.crossBorderOffer"><span>是否海外：</span>{{ productData.crossBorderOffer }}</div>
              <div v-if="productData.createTime"><span>创建时间：</span>{{ timestampToTime(productData.createTime) }}
              </div>
              <div v-if="productData.lastUpdateTime">
                <span>最后操作时间：</span>{{ timestampToTime(productData.lastUpdateTime) }}
              </div>
<!--              <div v-if="productData.expireTime"><span>过期时间：</span>{{ timestampToTime(productData.expireTime) }}-->
<!--              </div>-->
              <div v-if="productData.modifyTime"><span>修改时间：</span>{{ timestampToTime(productData.modifyTime) }}
              </div>
              <div v-if="productData.approvedTime"><span>审核时间：</span>{{ timestampToTime(productData.approvedTime) }}
              </div>
              <div v-if="productData.lastRepostTime">
                <span>最后重发时间：</span>{{ timestampToTime(productData.lastRepostTime) }}
              </div>
              <div v-if="productData.bookedCount"><span>成交量：</span>{{ productData.bookedCount }}</div>
              <div v-if="productData.sellerLoginId"><span>卖家旺旺：</span>{{ productData.sellerLoginId }}</div>
              <div v-if="productData.sellerId">
                <span>卖家ID：</span>{{ productData.sellerId }}
              </div>
              <div>
                <el-button size="small" v-if="!relation" type="warning" @click="toCloneProduct">转为自营商品</el-button>
              </div>
              <!--            <div class="encryptLogisticsOrderSupportChannel" v-if="productData.encryptLogisticsOrderSupportChannel">-->
              <!--              <span v-for="(item,index) in productData.encryptLogisticsOrderSupportChannel.supportChannels">-->
              <!--                {{getChannel(item)}}-->
              <!--              </span>-->
              <!--            </div>-->
              <div>
                <!--              <el-button size="small" v-if="!relation" type="warning" @click="productRelationAdd">关联商品</el-button>-->
                <!--              <span v-else>商品已关联</span>-->
              </div>
            </div>
            <product-sale-info :item="productData.productSaleInfo"></product-sale-info>
          </div>

        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="SKU" name="SKU" v-if="productData.productSkuInfos">
            <div class="sku-items">
              <div class="sku-item" v-for="(item,index) in productData.productSkuInfos">
                <div class="sku-image">
                  <el-image v-if="item.attributes" :preview-src-list="[skuImage(item.attributes)]" class="sku-image"
                            :src="skuImage(item.attributes)"></el-image>
                </div>
                <div class="sku-info">
                  <div class="sku-data">
                    <div v-if="item.skuId" class="skuId">skuId:{{ item.skuId }}</div>
                    <div v-if="item.cargoNumber" class="cargoNumber">指定规格的货号:{{ item.cargoNumber }}</div>
                    <div v-if="item.amountOnSale" class="amountOnSale">可销售数量:{{ item.amountOnSale }}</div>
                  </div>
                  <div class="sku-price">
                    <div v-if="item.retailPrice" class="retailPrice">建议零售价:￥{{ item.retailPrice }}</div>
                    <div v-if="item.price" class="price">报价时该规格的单价:￥{{ item.price }}</div>

                    <!--代销场景均使用该价格。无SKU商品查看saleInfo中的consignPrice-->
                    <div v-if="item.consignPrice" class="consignPrice">分销基准价:￥{{ item.consignPrice }}</div>
                    <div v-if="item.channelPrice" class="channelPrice">厂货通渠道专享价:￥{{ item.channelPrice }}</div>
                    <div v-if="item.cpsSuggestPrice" class="cpsSuggestPrice">CPS建议价:￥{{ item.cpsSuggestPrice }}</div>
                    <div v-if="item.jxhyPrice" class="jxhyPrice">精选货源一件起批价:￥{{ item.jxhyPrice }}</div>
                    <div v-if="item.jxhyPfPrice" class="jxhyPfPrice">精选货源价批发价:￥{{ item.jxhyPfPrice }}</div>
                  </div>
                  <div class="sku-attributes">
                  <span v-for="(item2,index2) in item.attributes">
                  {{ item2.attributeName }}:{{ item2.attributeValue }}</span>
                  </div>
                  <div>{{ item.specId }}</div>

                </div>
                <!--              <div style="width: 150px"><el-button size="small" type="primary" v-if="relation" @click="addShopCart(item)">加入购物车</el-button> </div>-->
              </div>

            </div>
          </el-tab-pane>
          <el-tab-pane label="产品属性" name="productAttribute">
            <div class="product-attribute" v-if="productData.productAttribute">
              <div class="attribute" v-for="(item,index) in productData.productAttribute" :key="index">
                <div>{{ item.attributeName }}:</div>
                <div><p class="attribute-balue">{{ item.value.join() }}</p></div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="介绍" name="description">
            <div v-html="productData.description"></div>
          </el-tab-pane>
          <el-tab-pane label="运费" name="productShippingInfo">

            <div class="freightTemplate" v-if="productData.productShippingInfo">
              <h4>商品运费费率</h4>
              <div v-for="(item,index) in productData.productShippingInfo.freightTemplate">
                <h4> 发货地址： {{ item.addressCodeText }}</h4>
                <template v-if="item.expressSubTemplate">
                  <div class="subTemplateDTO" v-if="item.expressSubTemplate.subTemplateDTO">
                    <div>计件类型:{{ expressTemplateChargeType(item.expressSubTemplate.subTemplateDTO.chargeType) }}
                    </div>
                    <div>是否系统模板:{{ item.expressSubTemplate.subTemplateDTO.isSysTemplate }}</div>
                    <div>
                      运费承担类型:{{ expressTemplateServiceChargeType(item.expressSubTemplate.subTemplateDTO.serviceChargeType) }}
                    </div>
                    <div>服务类型:{{ expressTemplateServiceType(item.expressSubTemplate.subTemplateDTO.serviceType) }}
                    </div>
                    <div>子模板类型:{{ expressTemplateSubType(item.expressSubTemplate.subTemplateDTO.type) }}</div>
                  </div>
                  <div class="rateListItem" v-for="(item2,i2) in item.expressSubTemplate.rateList">
                    <h3>{{ item2.toAreaCodeText }}</h3>
                    <div class="rateDTO" v-if="item2.rateDTO">
                      <div v-if="item2.rateDTO.firstUnit">
                        <template v-if="item.expressSubTemplate.subTemplateDTO.chargeType==0">首重（单位：克）</template>
                        <template v-if="item.expressSubTemplate.subTemplateDTO.chargeType==1">首件（单位：件）</template>

                        :{{ item2.rateDTO.firstUnit }}
                      </div>
                      <div v-if="item2.rateDTO.firstUnitFee">
                        <template v-if="item.expressSubTemplate.subTemplateDTO.chargeType==0">首重</template>
                        <template v-if="item.expressSubTemplate.subTemplateDTO.chargeType==1">首件</template>
                        的价格:￥{{ fenTo(item2.rateDTO.firstUnitFee) }}
                      </div>
                      <div v-if="item2.rateDTO.leastExpenses">最低一票:{{ item2.rateDTO.leastExpenses }}</div>
                      <div v-if="item2.rateDTO.nextUnit">续重/件单位:{{ item2.rateDTO.nextUnit }}</div>
                      <div v-if="item2.rateDTO.nextUnitFee">续重/件价格:￥{{ fenTo(item2.rateDTO.nextUnitFee) }}</div>
                      <div v-if="item2.rateDTO.lowerRange">重量下限:{{ item2.rateDTO.lowerRange }}</div>
                      <div v-if="item2.rateDTO.upperRange">重量上限:{{ item2.rateDTO.upperRange }}</div>
                    </div>
                  </div>
                </template>
              </div>

            </div>
          </el-tab-pane>
        </el-tabs>


      </div>
    </el-drawer>


    <el-dialog title="运费模板" :visible.sync="freightViable" :close-on-click-modal="false" width="500px"
               @close="resetForm_freight('zhuanData')">
      <el-form :model="zhuanData" :rules="rules_freight" ref="zhuanData" label-width="100px">
        <el-form-item>
          请核对：起批量及运费！
        </el-form-item>
        <el-form-item label="运费模板:" prop="freight_template_ids">
          <el-select v-model="zhuanData.freight_template_ids" multiple placeholder="请选择" size="small"
                     style="width: 100%;">
            <el-option v-for="item in freightList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <div class="btnbox">
          <el-button @click="resetForm_freight('zhuanData')" size="small">取消</el-button>
          <el-button @click="toCloneProduct_submit('zhuanData')" :loading="z_loading" type="primary" size="small">确定
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import alibabaProductApi from "./api";
import {Loading} from 'element-ui';
import {
  expressTemplateChargeType,
  expressTemplateServiceChargeType,
  expressTemplateServiceType, expressTemplateSubType,
  getChannel, statusToZH
} from "../config";
import {timestampToTime} from "../../../utils/util";
import ProductSaleInfo from "./components/productSaleInfo.vue";
import alibabaOrderApi from "../order/api";
import {fenTo} from "../util";

export default {
  components: {ProductSaleInfo},
  data() {
    return {
      filter: {
        page: 1,
        pageSize: 20,
        orderNo: null,
        createStartTime: null,
        createEndTime: null,
        orderStatus: null,//订单状态
        refundStatus: null,//退款状态
      },
      zhuanData: {
        freight_template_ids: [],
        product_ids: [],
        is_all: 0,
        channel_id: '',
        channel_type: '25',
        classify_id: ''
      },
      rules_freight: {
        freight_template_ids: [
          {
            required: true,
            message: '请选择运费模板',
            trigger: ['change', 'blur']
          }
        ],
      },
      isSub: false,
      productId: "",
      loading: false,
      dialog_loading: false,
      z_loading: false,
      shopProductId: null,
      activeName: "SKU",
      cateDialogVisible: false,
      dialogVisible: false,
      productAttribute: [],
      categoriesData: [],
      cateProps: {
        label: 'name',
        value: 'id',
        children: 'childLevel'
      },
      ruleForm: {
        one: '',
        two: '',
        business_category_id: "",
      },
      rules: {
        business_category_id: [
          {
            required: true,
            message: '请选择分类',
            trigger: ['change', 'blur']
          }
        ],
        one: [
          {
            required: true,
            message: '请选择店铺一级分类',
            trigger: ['change', 'blur']
          }
        ],
        two: [
          {
            required: true,
            message: '请选择店铺二级分类',
            trigger: ['change', 'blur']
          }
        ],

      },
      freightViable: false,
      freightList: [],
      myCateList1: [],
      myCateList2: [],
      relation: false,
      //	业务类型。1：商品，2：加工，3：代理，4：合作，5：商务服务。国际站按默认商品。
      bizTypes: ["", "商品", "加工", "代理", "合作", "商务服务"],
      productData: {},
      cartKey: "alibabaShopCart",
      freightTemplate: null,//运费模版
    }
  },
  methods: {
    fenTo,
    // 获取运费模板
    getFreightList() {
      this.$get(this.$api.selectTemplate).then((res) => {
        if (res.status == 200) {
          this.freightList = res.data;
          this.freightViable = true
        }
      });
    },
    statusToZH,
    timestampToTime(val) {
      return timestampToTime(parseInt(val))
    },
    expressTemplateSubType,
    expressTemplateServiceType,
    expressTemplateServiceChargeType,
    expressTemplateChargeType,
    getChannel,
    resetForm(formName) {
      this.cateDialogVisible = false;
    },
    skuImage(attrs) {
      for (let i = 0; i < attrs.length; i++) {
        if (attrs[i].skuImageUrl) {
          return attrs[i].skuImageUrl
        }
      }
    },
    open(offerId) {
      this.productId = offerId
      this.getData(offerId)

    },
    getData(offerId) {

      let loading = Loading.service({fullscreen: true, text: "1688数据加载中"});
      alibabaProductApi.info(offerId).then(res => {

        if (res.status == 200) {
          const data = res.data
          if (data.success) {
            this.isSub = data.isSub
            this.dialogVisible = true
            this.relation = data.relation
            this.productData = res.data.productInfo
            if(this.productData.productSkuInfos){
              this.activeName="SKU"
            }else{
              this.activeName="productAttribute"
            }
            if (this.productData.productAttribute) {
              let newAttributes = new Map
              this.productData.productAttribute.forEach(item => {


                if (newAttributes.has(item.attributeID)) {
                  let attObj = newAttributes.get(item.attributeID);
                  attObj.value.push(item.value)
                  newAttributes.set(item.attributeID, attObj)
                } else {
                  item.value = [item.value]
                  newAttributes.set(item.attributeID, item)
                }

              })
              this.productData.productAttribute = [...newAttributes.values()]
            }
          } else {

            if (data.message) {
              this.$message.error(data.message)
            } else {
              this.$message.error("商品信息获取失败")
            }
            this.dialogVisible = false
          }

        }
      }).finally(() => {
        loading.close()
      })
    },
    handleClose() {
      this.shopProductId = null
      this.dialogVisible = false
    },

    resetForm_freight(formName) {
      this.$refs[formName].resetFields();
      this.freightViable = false
    },
    // 转为自营商品 选择运费模版
    toCloneProduct() {
      if (this.isSub) {
        this.getFreightList()
      } else {
        alibabaProductApi.appShopUrl().then(res => {
          if (res.status == 200) {
            this.$confirm('您未订购阿里巴巴相关服务！确认前往阿里巴巴订购？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              window.open(res.data.url, "_blank");
            }).catch(() => {

            });
          }
        })

      }

      // this.freightViable = true
    },
    //转为自营商品 确认
    toCloneProduct_submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.zhuanData.product_ids = [this.productData.productID]
          this.z_loading = true
          alibabaProductApi.alibabaProductCloneCheck(this.zhuanData.product_ids).then(
            res => {
              if (res.status == 200) {
                if (res.data.platform) {
                  if (res.data.exist && res.data.exist.length > 0) {
                    let exist_link_pro_ids = [];
                    res.data.exist.forEach(item => {
                      exist_link_pro_ids.push(item["link_pro_id"] + "[" + item["product_id"] + "]")
                    })
                    this.$message.error(exist_link_pro_ids.join() + "已入库")
                    this.z_loading = false;
                  } else {
                    this.zhuanData.channel_id = res.data.platform.platform_authorize_id
                    this.zhuanData.channel_type = res.data.platform.type
                    this.$post(this.$api.cloneProduct, this.zhuanData).then((res) => {
                      this.zhuanData.product_ids = []
                      this.z_loading = false
                      if (res.status == 200) {
                        this.resetForm_freight(formName)
                        this.$message({
                          message: res.msg,
                          type: 'success'
                        });
                      }
                    });
                  }

                }

              }
            }
          )

        } else {
          return false;
        }
      });
    },
  },

}
</script>
<style scoped>
.product-container {
  padding: 0 20px 20px 20px;
  font-size: 12px;
}

.product-container .info {
  display: flex;
  gap: 20px;
}

.info .left {
  width: 40%;
}

.info .right {
  width: 60%;
}

.info .right .title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.info .right .attributes {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.info .right .attributes > div {
  width: 49%;
  font-size: 14px;
}

.info .right .attributes > div span {
  font-weight: bold;
  width: 100px;
  text-align: right;
  display: inline-block;
}

.info .right .encryptLogisticsOrderSupportChannel {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.product-attribute {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.product-attribute .attribute {
  box-sizing: content-box;
  width: 45%;
  display: flex;

}

.product-attribute .attribute div {
  padding: 8px;

}

.attribute-balue {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin: 0;
}

.product-attribute .attribute div:first-child {
  width: 100px;
  background-color: #dddddd;
  text-align: right;

  flex: 0 0 auto;
}

.sku-item {
  cursor: pointer;
  display: flex;
  gap: 15px;
  margin-bottom: 10px;
  background-color: rgba(225, 225, 225, 0.65);
  padding: 5px;
  border-radius: 5px;
}

.sku-item:hover {
  background-color: #3a8ee6;
  color: #FFFFFF;
}

.sku-info {
  line-height: 20px;
}

.sku-image {
  width: 80px;
  height: 80px;
}

.sku-data {
  display: flex;
  gap: 10px;
}

.sku-price {
  display: flex;
  gap: 10px;
}

.sku-attributes {
  display: flex;
  gap: 10px;
}

.freightTemplate {
}

.freightTemplate .subTemplateDTO {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.freightTemplate .rateListItem {
  margin-bottom: 10px;
  background-color: #e1e1e1;
  padding: 10px;
  border-radius: 5px;
}

.rateListItem h3 {
  margin-top: 0 !important;
  margin-bottom: 5px;
}

.freightTemplate .rateDTO {
  display: flex;
  flex-wrap: wrap;

}

.freightTemplate .rateDTO div {
  display: inline-block;
  margin-right: 10px;
  padding-left: 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/alibaba/product/alibabaProductInfo.vue